<template>
    <div class="user_all" v-loading="fullscreenLoading">

        <div class="user_search">
            <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
            <el-select
                    style="width: 250px"
                    v-model="selectRpc"
                    @change="changeRpc()"
                    :placeholder="this.$t('title.RPC_service')"
            >
                <el-option
                        v-for="item in optionRpc"
                        :key="item.rpcUrl"
                        :label="item.name"
                        :value="item.rpcUrl"
                ></el-option>
            </el-select>
            <span style="width: 100px;display: inline-block"></span>
            <el-select
                    style="width: 250px"
                    v-model="selectChain"
                    @change="changeChain()"
                    :placeholder="$t('title.Please_select_the_chain')"
            >
                <el-option
                        v-for="item in optionsChain"
                        :key="item"
                        :label="item+$t('title.chain')"
                        :value="item"
                ></el-option>
            </el-select>
        </div>
        <div class="user_search">
            <span style="width: 100px;display: inline-block">{{ $t('title.contract') }}：</span>
            <el-select
                    style="width: 250px"
                    v-model="selectConTem"
                    :placeholder="this.$t('title.please_choose')"
            >
                <el-option
                        v-for="item in optionConTem"
                        :key="item.id"
                        :label="`${item.rpcServer} - ${item.chainId}链 - ${item.contractName}`"
                        :value="item.contractAddress"
                ></el-option>
            </el-select>
        </div>
        <div class="user_search" style="display: flex">
            <span style="width: 100px;display: inline-block">用户：</span>
            <el-input v-model="searchAddressNum" type="primary" style="width: 250px"
                      :placeholder="this.$t('title.Please_enter_the_address')"></el-input>
            <el-button type="primary" style="margin-left: 30px" @click="searchAddNum()" :loading=Loading>{{ $t('title.search') }}
            </el-button>
            <span style="display: inline-block;margin-left: 30px">数量：</span>
            <span style="display: inline-block;margin-left: 10px">{{AddtNum}}</span>
        </div>
        <div class="user_search">
            <span style="width: 100px;display: inline-block">系统用户：</span>
            <el-select
                    style="width: 250px"
                    v-model="selectSystem"
                    :placeholder="this.$t('title.please_choose')"
            >
                <el-option
                        v-for="item in optionSystem"
                        :key="item.id"
                        :label="`${item.nickname} - ${item.address}`"
                        :value="item.address"
                ></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 30px" @click="searchSystem()" :loading=Loading>{{ $t('title.search') }}
            </el-button>
            <span style="display: inline-block;margin-left: 30px">数量：</span>
            <span style="display: inline-block;margin-left: 10px">{{SystemNum}}</span>
        </div>
        <div class="user_search">
            <span style="width: 100px;display: inline-block">质押金额：</span>
            <el-input v-model="inputPledge" type="primary" style="width: 250px"
                      placeholder="请输入金额" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <el-button type="primary" style="margin-left: 30px" @click="clPledge()" :loading=Loading>质押
            </el-button>
        </div>
        <div class="user_search">
            <span style="width: 100px;display: inline-block">解锁金额：</span>
            <el-input v-model="inputUnlock" type="primary" style="width: 250px"
                      placeholder="请输入金额" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            <el-button type="primary" style="margin-left: 30px" @click="clUnlock()" :loading=Loading>解锁
            </el-button>
        </div>
        <div class="user_search" style="float: right">

            <el-button type="primary" style="margin-left: 30px" @click="searAdd()">{{ $t('title.Refresh') }}
            </el-button>
        </div>
        <div class="con_table">
            <el-table
                    :data="tableData"
                    border
                    height="520"
                    style="width: 100%;margin-bottom: 30px;margin-top: 40px"
                    :header-cell-style="this.tableHeaderColor"
            >
                <el-table-column
                        :label="this.$t('title.Serial_number')"
                        fixed
                        align="center"
                        width="90">
                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.RPC_service')"
                        width="200"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.rpcServer}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Chain_id')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromChainId}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="地址-TKM地址"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromAddress}}</span>
                        <br>
                        <span>{{to_32_decimal(scope.row.fromAddress)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="当前总金额"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.fromAfterCoins}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label=" 操作金额"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.coins}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                       :label="this.$t('title.Gas_fee')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.gasFee}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="类型"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.type==301?'质押':scope.row.type==300?'投票查询':scope.row.type}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="hash"
                        width="400"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.hash}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        :label="$t('title.state')"
                        width="150"
                        align="center">
                    <template slot-scope="scope">
                        <span :style="scope.row.status==0?'color:red':'color:green'">{{scope.row.status==0?'已下架':scope.row.status==-1?'已发送待验证':'已上架'}}</span>
                        <!--                        -->
                    </template>
                </el-table-column>
                <el-table-column
                        :label="this.$t('title.Creation_time')"
                        width="200"
                        fixed="right"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{timestampToTime(scope.row.createTime)}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>

</template>

<script>
    import {
        getrpcserver,
        getchaininfo,
        userlList,
        usercontract,
        getaccount,
        transferPledge,
        transferList,


    } from '../../../api/interface'

    export default {
        name: 'Vote',
        components: {},
        data() {
            return {
                tableData: [],
                currentPage: 1,
                pagesize: 10,
                total: 0,
                isResponse: false,
                selectRpc: "",
                seleArr: [],
                optionRpc: [],
                selectChain: '',
                optionsChain: [],
                inputValue: '',
                searchValue: '',
                fullscreenLoading: false,
                Loading: false,

                selectConTem: '',
                optionConTem: [],
                searchAddressNum: '',
                AddtNum: '',
                inputAward: '',
                optionSystem: [],
                selectSystem: '',
                SystemNum: '',
                inputPledge: '',
                inputUnlock: '',

            }
        },
        methods: {
            searAdd(){
                this.getLog(301)
            },
            getLog(e) {
                let a = {
                    "type": e,
                    "page": 1,
                    "rows": 10
                }
                transferList(a).then(response => {
                    this.isResponse = false
                    if (response.code == 200) {
                        this.tableData = response.data.data
                    } else {
                        this.tableData = []
                    }

                })
            },
            clPledge() {
                if (this.inputPledge != '') {
                    let forad = ''
                    if (this.searchAddressNum == '' && this.selectSystem == '') {
                        this.$message.error('请选择From用户！')
                    } else {
                        if (this.searchAddressNum == '' && this.selectSystem != '') {
                            forad = this.selectSystem
                        } else if (this.searchAddressNum != '' && this.selectSystem == '') {
                            forad = this.searchAddressNum
                        } else {
                            forad = this.searchAddressNum
                        }
                        console.log(this.selectConTem)
                        let data = {
                            "from": forad,
                            "to": this.selectConTem,
                            "coins": this.inputPledge,
                            "rpcServer": this.selectRpc,
                            "chainId": this.selectChain
                        }
                        this.Loading = true
                        transferPledge(data).then(response => {
                            this.Loading = false
                            if (response.code == 200) {
                                this.$message.success('质押成功！')
                                this.getLog(301)
                            } else {
                                this.$message.error(response.msg)
                            }
                        })
                    }

                } else {
                    this.$message.error('请输入质押金额！')
                }
            },
            clUnlock() {
                if (this.inputUnlock != '') {

                } else {
                    this.$message.error('请输入解锁金额！')
                }
            },
            searchSystem() {

                if (this.selectSystem != '') {
                    let data = {
                        "address": this.selectSystem,
                        "chainId": this.selectChain,
                        "rpcServer": this.selectRpc
                    }
                    this.Loading = true
                    getaccount(data).then(response => {
                        this.Loading = false
                        this.SystemNum = response.data.balanceValue
                    })
                } else {
                    this.$message.error('请选择用户后进行查询！')
                }
            },
            searchAddNum() {

                if (this.searchAddressNum != '') {
                    let data = {
                        "address": this.searchAddressNum,
                        "chainId": this.selectChain,
                        "rpcServer": this.selectRpc
                    }
                    this.Loading = true
                    getaccount(data).then(response => {
                        this.Loading = false
                        this.AddtNum = response.data.balanceValue
                    })
                } else {
                    this.$message.error(this.$t('title.Please_enter_the_address')+'!')
                }

            },
            changeRpc() {
                this.fullscreenLoading = true
                let data = {rpcServer: this.selectRpc}
                getchaininfo(data).then(response => {
                    this.optionsChain = response.data
                    this.selectChain = this.optionsChain[0]
                    this.getUsers()
                })
            },
            changeChain() {
                this.fullscreenLoading = true
                this.getUsers()

            },
            getData() {
                getrpcserver().then(response => {
                    this.optionRpc = response.data
                    this.selectRpc = this.optionRpc[0].rpcUrl
                    let data = {rpcServer: this.optionRpc[0].rpcUrl}
                    getchaininfo(data).then(response => {
                        this.optionsChain = response.data
                        this.selectChain = this.optionsChain[0]
                        this.getUsers()
                    })
                })
                usercontract().then(response => {
                    if (response.code == 200) {
                        this.optionConTem = response.data
                        this.selectConTem = this.optionConTem[0].contractAddress
                    } else {
                        this.optionConTem = []
                        this.$message.error(response.msg)
                    }
                })

            },
            getUsers() {
                let data = {
                    "rpcServer": this.selectRpc,
                    "chainId": this.selectChain,
                    "address": "",
                    "page": 1,
                    "rows": 10000
                }
                userlList(data).then(response => {
                    this.fullscreenLoading = false
                    this.selectSystem = ''
                    if (response.code == 200) {
                        this.optionSystem = response.data.data
                    } else {
                        this.optionSystem = []
                        this.$message.error(response.msg)
                    }

                })
            },

        },
        created() {
            this.getData()
        }

    }
</script>
<style scoped>
    .user_all {
        padding: 20px 30px;
    }

    .user_search {
        margin-bottom: 30px;
    }
</style>
